<mat-card *ngIf="loading">
  <mat-card-header>
    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
  </mat-card-header>
  <mat-card-content>
    <ngx-skeleton-loader count="5"></ngx-skeleton-loader>
  </mat-card-content>
</mat-card>
<mat-card *ngIf="!loading">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>Consumo e produzione rilevati</mat-card-title>
      <mat-card-subtitle>kWh su base giornaliera</mat-card-subtitle>
    </mat-card-title-group>
    <div class="d-flex">
      <button mat-raised-button color="primary" class="d-inline-flex" (click)="getData(chartObj.selectedSite)"
        style="margin: 15px;">
        <div class="d-inline-flex" style="margin-top: 6px;">
          <i-tabler name="refresh" class="icon-20 text-white"></i-tabler>
        </div>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content #chartContainer>
    <apx-chart class="chart" #chart *ngIf="chartOptions.series !== undefined && chartOptions.chart"
      [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis ?? {}"
      [yaxis]="chartOptions.yaxis ?? {}" [title]="chartOptions.title ?? {}" [stroke]="chartOptions.stroke ?? {}"
      [legend]="chartOptions.legend ?? {}" [plotOptions]="chartOptions.plotOptions ?? {}"
      [dataLabels]="chartOptions.dataLabels ?? {}" [tooltip]="chartOptions.tooltip ?? {}"></apx-chart>

    <div class="col-12 text-center d-block"
      *ngIf="chartObj.startPeriod > 1 || (chartObj.type === 'custom' && chartObj.startPeriod > 1)">
      <div class="f-w-bold">
        Scorri tra i risultati
      </div>
      <img src="assets/images/miscellaneus/fast-backward.gif" width="20"
        style="transform: rotate(-180deg); position: absolute; margin-left: -25px;top: 33px; cursor: pointer;">
      <mat-slider class="scrollSlider" [max]="100" [min]="0" [step]="25" #slider>
        <input matSliderThumb [(ngModel)]="scrollValue" (input)="onSliderChange($event)">
      </mat-slider>
      <img src="assets/images/miscellaneus/fast-backward.gif" width="20"
        style="transform: rotate(-180deg); position: absolute; margin-left: 10px;top: 33px; cursor: pointer;">

    </div>
  </mat-card-content>

</mat-card>